import { useCallback, useEffect, useState } from 'react';

import { KingdomResponse, Province } from '../@types/KingdomResponse';
import { useIntelState } from '../context/IntelState';
import RestUtilities from '../services/RestUtilities';

export const setRecentData = async (
  server: number,
  intelDispatch: React.Dispatch<any>
) => {
  const response = await RestUtilities.get(
    `Kingdom/v1/Recent?server=${server}`
  );
  if (response.ok) {
    const kdResponse: KingdomResponse[] = response.content;
    const provinces: Province[] = [];
    kdResponse.forEach((kd: KingdomResponse, i: number) => {
      kd.provinces.forEach((p: Province) => {
        p.id = (i + 1) * 100 + p.slot;
        provinces.push(p);
      });
    });
    intelDispatch({ type: 'SET_RECENT_DATA', payload: provinces });
  }
};

export const useRecentIntel = () => {
  const { intelState, intelDispatch } = useIntelState();

  useEffect(() => {
    if (!intelState.recentData) {
      setRecentData(intelState.server, intelDispatch);
    }
  }, [intelDispatch, intelState.recentData, intelState.server]);
};
